export const AWARE_CONFIG = {
  METHOD: 'aware',
  URL_PARAM_METHOD: 'method',
  URL_PARAM_RETURN_URL: 'return_url',
  URL_PARAM_API_KEY: 'api_key',
  URL_PARAM_ERROR_MESSAGE: 'error_message',
  SUCCESS_COUNTDOWN_SECONDS: 3,
  FAIL_COUNTDOWN_SECONDS: 5,
  API_KEY_NAME: 'qodo-aware',
} as const;
